import {
  Box,
  Button,
  Card,
  CardContent,
  IconButton,
  InputAdornment,
  Link,
  TextField,
  Typography,
} from "@mui/material";
import { Form, Formik } from "formik";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
import { Dispatch } from "@reduxjs/toolkit";
import { CustomerLoginApi } from "../../redux/reducer/features/Auth/authSlice";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import PageLoader from "../app/PageLoader";
import { LoginFormValues } from "../../pages/Auth/Login";

const LoginInitialValues: LoginFormValues = {
  dmsDealerId: "",
  username: "",
  password: "",
};
const Schema = Yup.object<any>().shape<any>({
  username: Yup.string()
    .max(50, "username can only be upto 50 characters")
    .required("Psername is required"),
  password: Yup.string()
    .max(100, "Password can only be upto 100 characters")
    .required("Password is required"),
  dmsDealerId: Yup.string()
    .max(50, "dealer Id can only be upto 50 characters")
    .required("Dealer ID is required"),
});
interface CustomerLoginProps {
  handleSetLoginType: any;
}
export const CustomerLogin: React.FunctionComponent<CustomerLoginProps> = ({
  handleSetLoginType,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch<Dispatch<any>>();
  const [isLoading, setIsloading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const handleShowPasswordChange = () => setShowPassword(!showPassword);
  const [isError, setIsError] = React.useState(false);
  const onLoginComplete = (value: any) => {
    if (value === "Reset") {
      navigate("/Customer/Profile");
    } else {
      setIsloading(true);
      navigate("/");
    }
  };
  const onError = () => {
    setIsloading(false);
    setIsError(true);
  };
  const handleOnSubmit = (values: LoginFormValues) => {
    console.log("Dealer", values);
    setIsloading(true);
    dispatch(CustomerLoginApi(values, onLoginComplete, onError));
  };
  return (
    <>
      <PageLoader isLoading={isLoading}></PageLoader>

      <Formik
        initialValues={LoginInitialValues}
        validationSchema={Schema}
        onSubmit={(values) => {
          handleOnSubmit(values);
        }}
      >
        {({ values, errors, touched, handleChange, handleBlur }) => (
          <>
            <Form
              style={{
                width: "100%",
              }}
            >
              <Card variant="outlined">
                <CardContent>
                  <TextField
                    fullWidth
                    margin="dense"
                    variant="outlined"
                    type="text"
                    name="dmsDealerId"
                    id="dmsDealerId"
                    label="Dealer Number"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.dmsDealerId}
                    error={!!(touched.dmsDealerId && errors.dmsDealerId)}
                    helperText={touched.dmsDealerId ? errors.dmsDealerId : ""}
                  />
                  <TextField
                    fullWidth
                    type="text"
                    variant="outlined"
                    margin="dense"
                    name="username"
                    id="username"
                    label="User Name"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.username}
                    error={!!(touched.username && errors.username)}
                    helperText={touched.username ? errors.username : ""}
                  />
                  <TextField
                    fullWidth
                    variant="outlined"
                    name="password"
                    margin="dense"
                    id="password"
                    label="Password"
                    type={showPassword ? "text" : "password"}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.password}
                    error={!!(touched.password && errors.password)}
                    helperText={touched.password ? errors.password : ""}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            id="passwordVisibilityBtn"
                            onClick={handleShowPasswordChange}
                          >
                            {showPassword ? (
                              <VisibilityIcon />
                            ) : (
                              <VisibilityOffIcon />
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                  {isError === true ? (
                    <Typography
                      align="left"
                      variant="body1"
                      color={"error"}
                      gutterBottom
                    >
                      Invalid Credentials
                    </Typography>
                  ) : (
                    ""
                  )}
                  <Box mt={2}>
                    <Button
                      color="primary"
                      variant="contained"
                      type="submit"
                      fullWidth
                    >
                      Login
                    </Button>
                    <Link
                      sx={{
                        mt: 1,
                        display: "flex",
                        justifyContent: "flex-start",
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        handleSetLoginType("dealer");
                      }}
                    >
                      Dealer Login
                    </Link>
                  </Box>
                </CardContent>
              </Card>
            </Form>
          </>
        )}
      </Formik>
    </>
  );
};
